import React, { useRef } from "react";
import { Affix, Button, Card } from "antd";
import { useNavigate } from "react-router-dom";
import Header from "components/Common/Header";
import { isMobileView } from "components/Common/AppHelper";
import AddOrUpdateForm from "./AddOrUpdateForm";

const AddOrUpdateTNAByStyle = ({ width, isEdit }) => {
  const formRef = useRef(null);
  const navigate = useNavigate();

  return (
    <>
      <Affix offsetTop={0}>
        <Card className="p-fixed" style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}>
          <Header
            title="TNA By Styles"
            subTitle=""
            addLink="/"
            addText="Add New"
            actions={[
              <Button size="small" key={1} danger onClick={() => navigate("/tanda/tna-by-styles")}>
                Discard
              </Button>,
              <Button size="small" key={2} type="primary" onClick={() => formRef.current.submit()}>
                {isEdit ? "Update" : "Add"}
              </Button>,
            ]}
          />
        </Card>
      </Affix>

      <AddOrUpdateForm ref={formRef} isEdit={isEdit} />
    </>
  );
};

export default AddOrUpdateTNAByStyle;
